import { Component, OnInit, NgModule, ViewChild, OnDestroy } from '@angular/core';
import { Observable, concat, of, Subscription, Subject } from 'rxjs';
import { map, switchMap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

import { Title } from "@angular/platform-browser";
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from '../services/getglobalsettings.service'
import { CliListEntry } from '../shared/cli-list-entry';
import { Client } from '../shared/client';
import { RestApiService } from '../services/rest-api.service';
import { ClientApiService } from '../services/client-api.service';
import { CompanyselectorComponent } from '../visualcomponents/companyselector/companyselector.component'

@Component({
  selector: 'app-global-settings',
  templateUrl: './global-settings.component.html',
  styleUrls: ['./global-settings.component.css']
})
/**
 * Global-settings modal dialog for quick in-place configuration.
 *
 * `showDialog` copies the live settings object into an edit buffer and opens the dialog.
 * `onShowDialog` uses `concat` to first load the full client list, then load the currently
 * selected main company entry for the dropdown.
 *
 * `onConfirm` writes the edit buffer back to the live settings via `setGlobalSettings` and
 * closes the dialog. `onChangeMainCompany` updates `edited.mainCompanyId` from the dropdown
 * selection and shows a toast confirmation.
 */
export class GlobalSettingsComponent implements OnInit, OnDestroy {

  display: boolean = false;
  modal: boolean = true;

  settings: GlobalSettingsData;
  edited: GlobalSettingsData;

  /* main Company selection */

  clientslistMC: CliListEntry[];

  clientMC: CliListEntry;

  selectedCompany: string;
  
  totalRecordsMC: number;

  private _cliListQuery: Subscription

  @ViewChild('globalsettingsdialog') globalSettingsDialog: Dialog;

  @ViewChild('mainCompanyDd') mainCompany: DropdownModule;

  constructor(
    private restapi: RestApiService,
    private cliApi: ClientApiService,
    private messageService: MessageService,
    private globalsettingsservice: GetglobalsettingsService,
    private titleService: Title
  ) {
    this.selectedCompany = '';
  }

  /** Reads the live global settings and sets the browser title. */
  ngOnInit(): void {
    console.log('*** globalSettingsDialog onInit');

    this.settings = this.globalsettingsservice.getGlobalSettings();
    this.titleService.setTitle('Глобальные настройки');
  }

  /** Unsubscribes the client-list query. */
  ngOnDestroy() {
    console.log('*** globalSettingsDialog ngOnDestroy');

    if (this._cliListQuery) { this._cliListQuery.unsubscribe(); }
  }

  /** Copies `settings` into the edit buffer and opens the dialog. */
  showDialog() {
    console.log('*** globalSettingsDialog showDialog (just before): ' + JSON.stringify(this.clientMC));
    this.edited = this.settings;
    this.display = true;
    console.log('*** globalSettingsDialog showDialog (just after): ' + JSON.stringify(this.clientMC));
  }

  /** Loads the full client list then the current main company entry via `concat`. */
  onShowDialog() {
    console.log('*** globalSettingsDialog onShow: ');

    this._cliListQuery =
      concat(
        this.cliApi.getCliList()
          .pipe(map(
            (data: CliListEntry[]) => {
              this.clientslistMC = data;
              this.totalRecordsMC = data.length;
            }
          )),
        this.cliApi.getCliListEntry(this.globalsettingsservice.getMainCompanyId())
          .pipe(map(
            (data: CliListEntry[]) => {
              this.clientMC = data[0];
              console.log('*** globalSettingsDialog ngOnInit: ' + JSON.stringify(this.clientMC));
            }
          ))
      )
        .subscribe();

  //    .subscribe(
  //      (data: CliListEntry[]) => {
  //        this.clientslistMC = data;
  //        this.totalRecordsMC = data.length;

  //        this.cliApi.getCliListEntry(this.globalsettingsservice.getMainCompanyId())
  //          .subscribe(
  //            (data: CliListEntry[]) => {
  //              this.clientMC = data[0];
  //              console.log('*** globalSettingsDialog ngOnInit: ' + JSON.stringify(this.clientMC));
  //            });
  //      });      
  }

  /** Logs the dialog-hide event (diagnostic only). */
  onHideDialog() {
    console.log('*** globalSettingsDialog onHide');
  }

  /** Commits the edit buffer to global settings and closes the dialog. */
  onConfirm(text: string) {
    this.settings = this.edited;
    this.display = false;

    console.log('*** globalSettingsDialog onConfirm: ' + text)
    console.log('*** globalSettingsDialog onConfirm: (selectedCompany) ' + this.clientMC.CLIENTSNAME)

    this.globalsettingsservice.setGlobalSettings(this.settings);
  }

  /** Placeholder for access-group management (diagnostic only). */
  onAccessGroup() {
    console.log('*** globalSettingsDialog onAccessGroup')
  }

  /** Placeholder for new-company creation (diagnostic only). */
  onNewCompany() {
    console.log('*** globalSettingsDialog onNewCompany')
  }

  /** Logs the main-company click event (diagnostic only). */
  onClickMainCompany(e) {
    console.log('*** globalSettingsDialog onClickMainCompany: ' + e)
  }

  /** Applies the dropdown-selected company to `edited.mainCompanyId` and shows a toast. */
  onChangeMainCompany(e) {
    console.log('*** globalSettingsDialog onChangeMainCompany: ' + e)

    this.clientMC = e.value;

    console.log('*** globalSettingsDialog onChangeMainCompany: selectedCompany: ' + this.clientMC.CLIENTSNIKNAME)
    this.messageService.add({ severity: 'success', summary: 'Selected company: ', detail: this.clientMC.CLIENTSNIKNAME });

    this.edited.mainCompanyId = Number( this.clientMC.CLIID);

  }
}

/*
export class LoginFormComponent {
  login = '';
  password = '';

  constructor(private authService: AuthService, public appInfo: AppInfoService) { }

  onLoginClick(args) {
    if (!args.validationGroup.validate().isValid) {
      return;
    }

    this.authService.logIn(this.login, this.password);

    args.validationGroup.reset();
  }
}
*/

export class GlobalSettingsModule { }
